var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZapIconWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 27,
    viewBox: "0 0 16 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0548896 14.3213L7.19977 0.273331C7.28507 0.105624 7.45729 0 7.64544 0H14.7781C15.1719 0 15.4111 0.434093 15.2008 0.767026L9.75174 9.39334C9.54143 9.72627 9.78067 10.1604 10.1745 10.1604H14.6047C15.0308 10.1604 15.2616 10.6592 14.9858 10.984L1.73761 26.5835C1.36878 27.0177 0.677015 26.5958 0.894285 26.0691L5.15558 15.7387C5.29135 15.4095 5.04939 15.048 4.69336 15.048H0.500559C0.127368 15.048 -0.114292 14.654 0.0548896 14.3213Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapIconWhite);
export default __webpack_public_path__ + "static/media/zapIconWhite.79cc28d1c865c42ff0d8cf2c73e6258d.svg";
export { ForwardRef as ReactComponent };